import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CountdownComponent, CountdownEvent } from 'ngx-countdown';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'reservation-countdown',
  standalone: true,
  imports: [
    TranslateModule,
    CountdownComponent,
    SkeletonModule
  ],
  templateUrl: './reservation-countdown.component.html',
  styleUrl: './reservation-countdown.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReservationCountdownComponent {
  public reservedSeconds = input.required<number | null>();
  public ui = input<'full' | 'block'>('full');

  public onCountdownEnd = output<CountdownEvent>();

  public loading = computed(() => {
    return this.reservedSeconds() === null;
  })
}
